<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Presenting Companies
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
      { logo: require('@/assets/logos/zeebu.png'), class: 'full-logo', name: 'Zeebu', url: 'http://zeebu.com/' },
      { logo: require('@/assets/logos/midnight.svg'), class: 'full-logo', name: 'Midnight', url: 'https://midnight.network/' },
      { logo: require('@/assets/logos/rizzo.svg'), class: 'logo', name: 'Rizzo Network', url: 'https://rizzo.network/' },
      { logo: require('@/assets/singapore/sponsors/aethir.png'), class: 'logo', name: 'Aethir', url: 'https://aethir.com/' },
      { logo: require('@/assets/logos/dogeos.svg'), class: 'logo', name: 'DogeOS', url: 'https://www.dogeos.com/' },
      { logo: require('@/assets/logos/blockchain.svg'), class: 'full-logo', name: 'Blockchain.com', url: 'https://www.blockchain.com/' },
      { logo: require('@/assets/logos/coinbase.svg'), class: 'full-logo', name: 'Coinbase', url: 'https://www.coinbase.com/' },
      { logo: require('@/assets/singapore/sponsors/coinlist.svg'), class: 'full-logo', name: 'CoinList', url: 'https://coinlist.co/' },
      { logo: require('@/assets/logos/bittensor.svg'), class: 'full-logo', name: 'Bittensor', url: 'https://bittensor.com/' },
      { logo: require('@/assets/logos/defai.png'), class: 'full-logo', name: 'DEFAI.GG', url: 'https://www.defai.gg/' },
      { logo: require('@/assets/logos/wellspring.png'), class: 'full-logo', name: 'Wellspring', url: 'https://wellspring.money/' },
      { logo: require('@/assets/logos/antix.png'), class: 'logo libera', name: 'Antix In', url: 'https://antix.in/' },
      { logo: require('@/assets/singapore/sponsors/sapien.png'), class: 'full-logo', name: 'Sapien',  url: 'https://game.sapien.io' },
      { logo: require('@/assets/logos/inception.svg'), class: 'full-logo', name: 'Inception Capital', url: 'https://www.inception.capital/' },
      { logo: require('@/assets/logos/tsangroup.png'), class: 'full-logo', name: 'TsangGroup', url: 'https://www.tsang.group/' },
      { logo: require('@/assets/logos/nubila.svg'), class: 'full-logo', name: 'Nubila', url: 'https://www.nubila.ai/' },
      { logo: require('@/assets/logos/trive.webp'), class: 'full-logo', name: 'Trive Digital', url: 'https://digital.trive.vc/' },
      { logo: require('@/assets/logos/beam.svg'), class: 'full-logo', name: 'BEAM', url: 'https://onbeam.com/' },
      { logo: require('@/assets/logos/zigchain.webp'), class: 'full-logo', name: 'ZigChain', url: 'https://zigchain.com/' },
      { logo: require('@/assets/logos/aa.webp'), class: 'full-logo', name: 'Assemble Asia', url: 'https://www.assemble-asia.com/' },
      { logo: require('@/assets/logos/stix.svg'), class: 'full-logo', name: 'STIX', url: 'https://www.stix.co/' },
      { logo: require('@/assets/logos/naoris.svg'), class: 'full-logo', name: 'Naoris', url: 'https://www.naorisprotocol.com/' },
      { logo: require('@/assets/logos/luxxfolio.png'), class: 'full-logo', name: 'LuxxFolio', url: 'https://www.luxxfolio.com/' },
      { logo: require('@/assets/logos/ltp.svg'), class: 'full-logo', name: 'LTP', url: 'https://www.liquiditytech.com/en' },
      { logo: require('@/assets/logos/depinx.png'), class: 'full-logo', name: 'DepinX', url: 'https://depinx.com/' },
      { logo: require('@/assets/logos/blockdaemon.svg'), class: 'full-logo', name: 'Blockdaemon', url: 'https://www.blockdaemon.com/' },
      { logo: require('@/assets/logos/bitsafe.svg'), class: 'full-logo', name: 'Bitsafe', url: 'https://www.bitsafe.finance/' },
      { logo: require('@/assets/logos/q42.png'), class: 'full-logo', name: 'Q42', url: 'https://q42.co/' },
      { logo: require('@/assets/logos/reserveone.png'), class: 'full-logo', name: 'ReserveOne', url: 'https://reserveone.com/' },
      { logo: require('@/assets/logos/atw.webp'), class: 'full-logo', name: 'ATW'},
      { logo: require('@/assets/logos/caladan.png'), class: 'full-logo', name: 'Caladan', url: 'https://caladan.xyz/' },
      { logo: require('@/assets/logos/c2.png'), class: 'full-logo', name: 'C squared Ventures', url: 'https://www.csquared.vc/' },
      { logo: require('@/assets/logos/moonhill.png'), class: 'full-logo', name: 'Moonhill', url: 'https://www.moonhill.capital/' },
      { logo: require('@/assets/logos/macrosmos.svg'), class: 'full-logo', name: 'Macrosmos', url: 'https://www.macrocosmos.ai/' },
      { logo: require('@/assets/logos/0g.svg'), class: 'logo', name: '0G', url: 'https://0g.ai/' },
      { logo: require('@/assets/logos/cryptoknights.png'), class: 'full-logo', name: 'CryptoKnights', url: 'https://www.cryptoknights.tv/' },
      { logo: require('@/assets/logos/ida.webp'), class: 'full-logo', name: 'IDA', url: 'https://www.idafi.xyz/' },
      { logo: require('@/assets/logos/finder.svg'), class: 'full-logo', name: 'Finder.com', url: 'https://finder.com/' },
      { logo: require('@/assets/logos/upside.png'), class: 'full-logo', name: 'Upside', url: 'https://www.upside.gg/' },
      { logo: require('@/assets/logos/alphaton.svg'), class: 'full-logo', name: 'AlphaTON', url: 'https://alphatoncapital.com/' },
      { logo: require('@/assets/logos/miden.svg'), class: 'full-logo', name: 'Miden', url: 'https://miden.xyz/' },
      { logo: require('@/assets/logos/lunar.svg'), class: 'full-logo', name: 'Lunar Digital Assets', url: 'https://www.lunardigitalassets.io/' },
      { logo: require('@/assets/logos/manifold.svg'), class: 'full-logo', name: 'Manifold', url: 'https://www.manifold.inc/' },
      { logo: require('@/assets/logos/bitmart.svg'), class: 'full-logo', name: 'BitMart', url: 'https://www.bitmart.com/' },
      { logo: require('@/assets/logos/own.png'), class: 'full-logo', name: 'Own. App', url: 'https://www.ownapp.co/' },
      { logo: require('@/assets/logos/estatex.png'), class: 'full-logo', name: 'EstateX', url: 'https://www.estatex.eu/' },
      { logo: require('@/assets/logos/pact.png'), class: 'logo', name: 'Pact Swap', url: 'https://pactswap.io/' },
      { logo: require('@/assets/nashville/sponsors/kredete.png'), class: 'full-logo', name: 'Kredete', url: 'https://www.kredete.com/' },
      { logo: require('@/assets/logos/zkalyx.png'), class: 'full-logo', name: 'Zkalyx', url: 'https://www.zkalyx.com/' },
      { logo: require('@/assets/logos/matterfi.svg'), class: 'full-logo', name: 'MatterFi', url: 'https://www.matterfi.com/' },
      { logo: require('@/assets/logos/manifest.png'), class: 'full-logo', name: 'Manifest', url: 'https://manifest.network/' },
      { logo: require('@/assets/logos/backstage.svg'), class: 'full-logo', name: 'Backstage', url: 'https://backstage.global/' },
      { logo: require('@/assets/logos/raiinmaker.png'), class: 'full-logo', name: 'Raiinmaker', url: 'https://www.raiinmaker.com/' },
      { logo: require('@/assets/logos/planck.svg'), class: 'full-logo', name: 'Planck', url: 'https://www.plancknetwork.com/' },
    ]);
    return {
      partners
    };
  },
};
</script>